module.exports = __webpack_public_path__ + "img/BINHCN2NXXX.84df14c0.png";